import type { ReactNode } from "react"

import { useIsMobile } from "@/hooks/use-mobile"
import AppMobileLayout from "@/layouts/app/app-mobile-layout"
import AppSidebarLayout from "@/layouts/app/app-sidebar-layout"
import type { BreadcrumbItem } from "@/types"

interface AppLayoutProps {
  children: ReactNode
  breadcrumbs?: BreadcrumbItem[]
}

export default function AppLayout({
  children,
  breadcrumbs,
  ...props
}: AppLayoutProps) {
  const isMobile = useIsMobile()

  if (isMobile) {
    return <AppMobileLayout>{children}</AppMobileLayout>
  }

  return (
    <AppSidebarLayout breadcrumbs={breadcrumbs} {...props}>
      {children}
    </AppSidebarLayout>
  )
}
